import { render, staticRenderFns } from "./ImageWidgetPanel.vue?vue&type=template&id=f4c118d0&scoped=true"
import script from "./ImageWidgetPanel.vue?vue&type=script&lang=js"
export * from "./ImageWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./ImageWidgetPanel.vue?vue&type=style&index=0&id=f4c118d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c118d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c118d0')) {
      api.createRecord('f4c118d0', component.options)
    } else {
      api.reload('f4c118d0', component.options)
    }
    module.hot.accept("./ImageWidgetPanel.vue?vue&type=template&id=f4c118d0&scoped=true", function () {
      api.rerender('f4c118d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/ImageWidgetPanel.vue"
export default component.exports